import { StandaloneImage } from '@/base/components/content/Image';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const HantLabradorImage: LabradorComponent = ({ type, data, meta }) => (
  <StandaloneImage
    src={data.src}
    alt={data.alt}
    caption={data.showCaption && data.caption}
    byline={data.showCaption && data.byline}
    {...withDebugMetadata({ type, meta })}
  />
);

export default HantLabradorImage;
